<template>
  <div class="customer-info" dir="rtl">
    <div class="login-card-outer">
      <div
        ref="form"
        v-model="valid"
      >
        <div class="login-card mt-10">
          <div v-if="level==1">
            <p class="title">
              {{ $t('addcusomerNumber') }}
            </p>
          </div>
          <div class="relative">

            <v-icon>
              mdi-cellphone-iphone
            </v-icon>
            <v-text-field
              :label="$t('customerNumber')"
              v-model="mobile"
              :rules="[rules.required, rules.mobile]"
              outlined
            ></v-text-field>
          </div>
          <div class="relative" v-if="level==2"
          >
            <v-icon>
              mdi-account
            </v-icon>
            <v-text-field
              :label="$t('nameLastName')"
              v-model="fullName"
              :rules="[rules.required, rules.fullName , rules.PersianFullName]"
              outlined
            ></v-text-field>
          </div>
        </div>
        <div>
          <button class="btn login-btn" v-on:click="login()" v-if="level==2">
            {{ $t('signUp') }}
          </button>
          <button class="btn login-btn" v-on:click="go_to_categories()" v-if="user_registered">
            {{ $t('submitRequest') }}
          </button>
          <div v-if="level==1">
            <div v-on:click="level=2" v-if="not_register">
              {{ $t('customernotFind') }}
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>
<script>
import { bus } from '../../main.js'
  export default {
    props:[
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        mobile: '',
        fullName: '',
        customer_name: '',
        password: '',
        valid: true,
        not_register: false,
        user_registered: false,
        level: 1,
        rules: {
          required: value => !!value || 'necessary',
          fullName: value => value.length <= 30 || 'maxCharacter',
          PersianFullName: value => {
            const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
            return pattern.test(value) || 'nameNotFarsi'
          },
          mobile: value => {
            const pattern = /^(\+98|0098|98|0)?9\d{9}$/
            return pattern.test(value) || 'wrongMobileFormat'
          },
        },
      }
    },
watch: {
      mobile: function () {
        this.not_register = false
        this.user_registered = false
        this.fullName = ''

        console.log('mobile changed')
        if (this.mobile.length == 11 && this.level == 1) {
          this.login()
        }
      }
    },
    methods: {
      login () {
        var self = this
        if (this.level == 1) {
          const send_data = {
            Phone: this.mobile,
          }
          // this.axios.post('/Register' , send_data,{
          this.axios.post('/CheckExistsMobileNo', send_data, {})
            .then(response => {
              if (response.data.error == 0) {
                console.log('response', response)
                self.user_registered = true
                self.fullName = response.data.msg
                // self.level = 2;
              } else {
                self.not_register = true
              }
              // this.$router.push({ path: "/post-login", params: {} });
            }).catch(e => {
            this.errors.push(e)
          })
        } else if (this.level == 2) {
          var eddited_mobile = self.mobile.substring(1)
          eddited_mobile = '+98' + eddited_mobile
          if (this.mobile != '' && this.fullName != '') {
            const send_data = {
              MobileNo: eddited_mobile,
              Password: this.password,
              OsName: 'win',
              AppNo: '3',
              OsVersion: '5',
              DeviceModel: 'android',
            }
            // this.axios.post('/Register' , send_data,{
            this.axios.post('/CustomerRegistration', send_data, {})
              .then(response => {
                if (response.data.error == 0) {
                  console.log('response login', response)

                  localStorage.setItem('profile', JSON.stringify(response.data.profile))
                  localStorage.setItem('phone', eddited_mobile)
                  localStorage.setItem('password', self.password)

                  self.$router.push({ path: '/post-login', params: {} })
                }
              }).catch(e => {
              this.errors.push(e)
            })
          }
        }
        if (this.mobile == '') {
          this.errors.push('writeYourNumber')
        }
        if (this.fullName == '') {
          this.errors.push(this.$t('PleaseInsertName'))
        }
      },
      go_to_categories () {
        // var PassingData = {'on_site_service':OnSite}
        if (this.fullName != '') {
          var passing_data = JSON.parse(localStorage.getItem('request_data'))
          passing_data.customer_mobile = this.mobile
          passing_data.customer_name = this.fullName
          localStorage.setItem('request_data', JSON.stringify(passing_data))

          this.$router.push({ name:'Categories', params:{ passing_data:this.passing_data } })
        } else {
          bus.$emit('show_dialog', ['error', 'writeCustomerNumber'])
        }
      }
    }
  }
</script>
